module.exports = __webpack_public_path__ + "static/media/team-alistair-gillespie.b5da31f6.png";